<loader-overlay-component [show]="isloading"></loader-overlay-component>
<div class="mainBody">
    <div class="dmv-search-results inner-home">
        <div class="container">
            <div class="row no-margin">
                <div class="col-6 col-sm-2 mt-4"><a><button
                            class="btn btn-primary btn-back top-back-button " (click)="back()"><i
                                class="fa fa-chevron-left text-left"></i> Back</button></a></div>
                <div class="col-12 col-sm-8 mt-4">
                    <div id="searchResu">Contact Info</div>
                </div>
                <div class="col-6 col-sm-2 icon-cart mt-4">

                </div>
             
                <div class="row w100 m-auto">
                    <div class="col-12 col-sm-8 col-md-6  m-auto" role="alert" *ngIf="errorMessage">
                        <div class="alert alert-danger homeError">   
                            {{errorMessage}}
                        </div>
                     </div>
    
                  
                        <div *ngIf="userStoreService?.outComeText" class="col-12 alert alert-info" role="alert"  > &nbsp;<span [innerHTML]="userStoreService?.outComeText"></span></div>
                   
                    <div class="col-12 col-sm-12">
                        <!-- <div class="col-12 alert-danger" role="alert"> Please correct fields in error. </div>
                        <div class="col-12 asteriskMessage"> *Fields marked with an asterisk are required </div> -->
                       <div class="billing-detail">
                            <div class="billing-detail-row">
                                <div class="row">
                                    <div class="col-12 col-sm-12">
                                        <div class="row">
                                            <div class="col-12 col-sm-12">
                                                <div class="rectangle-wrapper display-webkit-box">
                                                    <div id="pin" class="lh21 lightHd">Name</div>
                                                    <div class="merc-number">{{userStoreService?.getUserProfile()?.contactInfo?.firstName}} {{userStoreService?.getUserProfile()?.contactInfo?.lastName}}
                                                    </div>
                                                </div>
                                                <div class="rectangle-wrapper">
                                                    <div id="pin" class="lightHd">Phone</div>
                                                    <div  class="merc-number">{{formatedPhoneNumber(userStoreService?.getUserProfile()?.contactInfo?.phoneNumber)}}</div>
                                                    <div class="checkbox-container mobilePhone-profile disabled" *ngIf="userStoreService?.getUserProfile()?.contactInfo?.phoneNumber">
                                                        <span >Mobile</span>
                                                        <label class="d-block cursorPonter">
                                                            <input type="checkbox" disabled ="disabled" [checked]="userStoreService?.getUserProfile()?.contactInfo?.mobile"   name="mobile" >
                                                            <span class="checkmark-default" ></span>             
                                                         </label> 
                                                    </div>  
                                                </div>
                                                <div class="rectangle-wrapper">
                                                    <div id="pin" class="lightHd">Email/Id</div>
                                                    <div class="merc-number">{{userStoreService?.getUserProfile()?.contactInfo?.emailAddress}}</div>
                                                </div>
                                                <div class="rectangle-wrapper">
                                                    <div id="pin" class="lightHd">Tax Collector</div>
                                                    <div class="merc-number">{{taxCollectorName()}}</div>
                                                </div>
                                                <div class="rectangle-wrapper display-type-webkit-box">
                                                    <div id="pin" class="lightHd">Mailing Address</div>
                                                    <div class="merc-number">{{userStoreService?.getUserProfile()?.contactInfo?.address?.line1}}<br *ngIf="userStoreService?.getUserProfile()?.contactInfo?.address?.city || userStoreService?.getUserProfile()?.contactInfo?.address?.stateCode || userStoreService?.getUserProfile()?.contactInfo?.address?.postalCode"/>
                                                        {{userStoreService?.getUserProfile()?.contactInfo?.address?.city}}{{(userStoreService?.getUserProfile()?.contactInfo?.address?.city && (userStoreService?.getUserProfile()?.contactInfo?.address?.stateCode || userStoreService?.getUserProfile()?.contactInfo?.address?.postalCode))?', ':''}}{{userStoreService?.getUserProfile()?.contactInfo?.address?.stateCode}} {{userStoreService?.getUserProfile()?.contactInfo?.address?.postalCode}}
                                                    </div>
                                                </div>
                                                <div class="rectangle-wrapper">
                                                    <div id="pin" class="lightHd">Date of Birth</div>
                                                    <div class="merc-number">{{userStoreService?.getUserProfile()?.contactInfo?.dateOfBirth  | date:'MM/dd/yyyy'}}</div>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                    
                                    <div class="w100">
                                       
                                        <div class="deleteIcon-alignmet p-r"  >
                                           
                                             <i class="icon-group-10" (click)="editContactInfo()" > <svg-image   color="#01a5e0" name="Icon-icon-edit" [width]="24" [height]="24"></svg-image>
                                       </i>
                                          </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="row">
                        <div class="col-12 col-sm-12 mt-2">
                            <a href="javascript:void(0)" class="textLink contInfoLink" (click)="changeEmail()">Change email address</a>
                        </div>
                        <div class="col-12 col-sm-12 mt-2">
                            <a href="javascript:void(0)" class="textLink contInfoLink" (click)="changePassword()"> Change password</a>
                        </div>

                        <div class="col-12 col-sm-12 mt-2">
                            <a href="javascript:void(0)" class="textLink contInfoLink" (click)="cancelEnrollment()"> Cancel my enrollment & discontinue my user account</a>
                        </div>
                        
                    </div>

                    </div>

                </div>


            </div>

            <div class="container mt-5  text-center">

                <a><button class="btn btn-primary  btn-continue m-auto" (click)="back()">Close</button></a></div>
        </div>
    </div>
</div>